import React from 'react';
import './OrderCardPrice.less';
import {convertPrice} from "../../../helpers/format.helper";

export const OrderCardPrice = ({price}) => {
	return <span className="order-card-price">{convertPrice(price)}</span>
}
